import React, { useCallback, useEffect, useState } from 'react';
import { Button, Card, Space, Table, Tag, message, Avatar } from 'antd';
import { PlusOutlined, EyeOutlined, UserOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import api from '../../services/api';
import { useUniverse } from '../../contexts/UniverseContext';

const AnimationNpcs = () => {
  const navigate = useNavigate();
  const { selectedUniverseId } = useUniverse();
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);

  const fetchItems = useCallback(async () => {
    setLoading(true);
    try {
      const params = {};
      if (selectedUniverseId) {
        params.universe_id = selectedUniverseId;
      }
      const response = await api.get('/api/admin/animation-npcs', { params });
      setItems(response.data?.items || []);
    } catch (error) {
      message.error(error.response?.data?.error || 'Erreur lors du chargement');
    } finally {
      setLoading(false);
    }
  }, [selectedUniverseId]);

  useEffect(() => {
    fetchItems();
  }, [fetchItems]);

  const columns = [
    {
      title: '',
      dataIndex: 'avatar',
      key: 'avatar',
      width: 56,
      render: (avatar) => <Avatar src={avatar} icon={<UserOutlined />} />,
    },
    { title: 'Nom', dataIndex: 'name', key: 'name' },
    { title: 'Univers', dataIndex: 'universe_name', key: 'universe_name' },
    { title: 'Occupation', dataIndex: 'occupation', key: 'occupation' },
    {
      title: 'Statut',
      dataIndex: 'status',
      key: 'status',
      render: (status) => <Tag color={status === 'validated' ? 'green' : 'default'}>{status}</Tag>,
    },
    { title: 'Créé par', dataIndex: 'created_by_pseudo', key: 'created_by_pseudo' },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <Button icon={<EyeOutlined />} onClick={() => navigate(`/animation-npcs/detail/${record.id}`)}>
          Ouvrir
        </Button>
      ),
    },
  ];

  return (
    <Card
      title="PNJ d'animation"
      extra={(
        <Space>
          <Button type="primary" icon={<PlusOutlined />} onClick={() => navigate('/animation-npcs/new')}>
            Nouveau PNJ d'animation
          </Button>
        </Space>
      )}
    >
      <Table
        rowKey="id"
        loading={loading}
        columns={columns}
        dataSource={items}
        pagination={{ pageSize: 20 }}
      />
    </Card>
  );
};

export default AnimationNpcs;
